import React from "react";
import './ServiceMaster.css';
import { useNavigate } from "react-router-dom";
const ServiceMaster = () => {
  const navigate = useNavigate();
  const handleAddButtonClick = () => {
    navigate('/addServiceMaster');
  };

  const handleEditButtonClick = () => {
    navigate('/editServiceMaster');
  };


  return (
    <div className="service-master">
      <div className="outside-service-master">
        {/* <h3>Service Master</h3> */}
      </div>
      <div className="service-master-table">
        <div className="inside-service-master">
          <h3>Service Master</h3>
        </div>
        <div className="service-master-containerbody">
          <div className="service-masterButtons">
            <button className="btn-service-master" onClick={handleAddButtonClick} style={{ visibility: "hidden" }}>ADD</button>
          </div>
        </div>
        <div className='table-div-service'>
          <table className='fdbk-service'>
            <thead className="theadtr-service" >

              <tr  >
                <th>Service ID</th>
                <th>Service Name</th>
                <th>Parent ID</th>
                <th>Display Order</th>
                {/* <th style={{ display: "none" }}>Action</th> */}
              </tr>
            </thead>
            <tbody  >
              <tr>
                <td>1.</td>
                <td>Admin</td>
                <td>0 </td>
                <td>2 </td>
                {/* <td>
                  <button className="editbutton-service" onClick={handleEditButtonClick} style={{ display: "none" }}> Edit </button>

                </td> */}
              </tr>
              <tr>
                <td>2.</td>
                <td>User</td>
                <td> User</td>
                <td>1 </td>
                {/* <td>
                  <button className="editbutton-service" style={{ display: "none" }}> Edit </button>

                </td> */}
              </tr>
              <tr>
                <td>3.</td>
                <td>Guest</td>
                <td> User</td>
                <td>2 </td>
                {/* <td>
                  <button className="editbutton-service" style={{ display: "none" }}> Edit </button>

                </td> */}
              </tr>
             
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default ServiceMaster;